import React, { useEffect } from 'react';
import { ICdBuilderProps, CdBuilder } from './CdBuilder';
import { useApplicationContext } from './context/useApplicationContext';
import ErrorWrapper from './ErrorWrapper';
import SpinnerWrapper from './SpinnerWrapper';
import { initCdItems } from '../../store/order/cdBuilder';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { useAppDispatch } from '../../store/store';

export type ICdBuilderContainerProps = Omit<ICdBuilderProps, 'orderDetails'>;

export const CdBuilderContainer: React.FC<ICdBuilderContainerProps> = (props) => {
  const [{ error, order }] = useApplicationContext();
  const cdItems = useSelector((rootStore: RootStore) => rootStore.order.cdBuilder.cdItems);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // put initial empty data. Initial logic, moved from App.ts
    dispatch(initCdItems(props.ownerId, []));
  }, [props.ownerId, dispatch]);

  return (
    <SpinnerWrapper spinning={(!order && !error) || !cdItems[props.ownerId]}>
      <ErrorWrapper errorMessage={error}>
        <CdBuilder orderDetails={order!} {...props} />
      </ErrorWrapper>
    </SpinnerWrapper>
  );
};
